let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gAgAQ")).then(() => parcelRequire('8mcrK'));